/** Node.js environment values (matches `process.env.NODE_ENV`). */
export const NODE_ENV = {
  PRODUCTION: 'production',
  DEVELOPMENT: 'development',
  TEST: 'test',
} as const;

/**
 * Accepted `NEXT_PUBLIC_ENV` values, including the short aliases CI / Key Vault
 * may use. Distinct from {@link NODE_ENV}, which only ever reports
 * `production`/`development`/`test`.
 */
const DEPLOYMENT_ENV = {
  PRODUCTION: 'production',
  PRODUCTION_ALIAS: 'prod',
  STAGING: 'staging',
  TEST: 'test',
  DEVELOPMENT: 'development',
  DEVELOPMENT_ALIAS: 'dev',
  LOCAL: 'local',
} as const;

/** `NEXT_PUBLIC_ENV` values that identify the live production deployment. */
const PRODUCTION_ENV_VALUES: readonly string[] = [
  DEPLOYMENT_ENV.PRODUCTION,
  DEPLOYMENT_ENV.PRODUCTION_ALIAS,
];

/**
 * True only on the live production deployment (breedlogic.com.au).
 */
export function isProductionDeployment(): boolean {
  const raw = (
    process.env.NEXT_PUBLIC_ENV ||
    (process.env.NODE_ENV === NODE_ENV.PRODUCTION
      ? DEPLOYMENT_ENV.PRODUCTION
      : DEPLOYMENT_ENV.DEVELOPMENT)
  )
    .trim()
    .toLowerCase();
  return PRODUCTION_ENV_VALUES.includes(raw);
}
